import { WeatherLoaderWebSource } from '@fe/weather';
import { WeatherAccessInfo } from '../../webscoket/services/worker-weather-service';

export function toSource(input: WeatherAccessInfo): WeatherLoaderWebSource {
    return {
        type: 'web',
        server1: input.server1,
        server2: input.server2,
        strategy: input.strategy,
        requestMethod: 'GET',
        requestHeaders: {
            Authorization: `Basic ${btoa(`${input.userId}:${input.password}`)}`
        }
    };
}
